import { Box } from "@material-ui/core";
import React from "react";

export const Content: React.FC = ({ children }) => {
  return (
    <Box
      display="flex"
      flexGrow={1}
      overflow="hidden"
      minHeight={600}
      boxSizing="border-box"
    >
      {children}
    </Box>
  );
};
